//GeneratorFlag:[NoChange]
import Province from './province';
import Country from './country';

export default {Province, Country}
export{Province, Country}